export default __webpack_public_path__ + "static/media/offroad_class_params.7ba449d8.png";